// extracted by mini-css-extract-plugin
export var Sticky = "JoG3M";
export var StickyLeft = "_8LimR";
export var StickyMain = "_7kndA";
export var StickyMedia = "q09S8";
export var StickyP = "JRLkU";
export var StickyRight = "aiZOW";
export var s1 = "_8WhcZ";